import { TXGridTemplate } from "../../../types/common/templates.types";

export const X_GRID_COL_2: TXGridTemplate = {
  "Grille à 2 Colonnes": {
    template: [
      {
        name: "XGrid",
        props: {
          all: {
            columns: 2,
          },
        },
      },
    ],
  },
};
